import { useState, useEffect, useCallback, useMemo, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import MainLayout from 'views/layouts/Main'
import BluesiteTable from 'views/components/UI/BluesiteTable'
import ModalSkills from './modal-skills'
import {
  ActionAddSkillCreateProcess,
  ActionDeleteSkillCreateProcess,
} from 'views/components/UI/BluesiteTable/Actions/GridActions'
import {
  Container,
  StepsContainer,
  NextButtonContainer,
  Row,
  SelectContainer,
  ButtonContainer,
  Line,
  LineContainer,
  CardWithBadgeContainer,
  Badge,
  SparkleIcon,
  SkillsSelectContainer,
  ButtonContainerAI,
  SelectAndButtonContainer,
  HeaderContainer,
  TitleContainer,
  TitleIcon,
} from './styled'
import { H2, H4, H5, SubtitleBold } from 'views/components/UI/Text'
import MinimumRecord from './MinimumScore/skill-minimun-score'
import Steps from 'views/components/Stepper'
import ModalLoader from 'views/components/UI/ModalLoader/modal-loader'
import { Button, BackButton } from 'views/components/UI/Buttons'
import { useNotification } from 'lib/context/notification.context'
import Select from 'views/components/UI/Select'
import { STEPS_NEW_PROCESS } from '../constants'
import { platformAdminRoutes } from 'router/routes'
import { rootProcessSelector, setStepFour, stepThreeSelector, stepFourSelector } from 'ducks/createProcess'
import { generalDataSelector } from 'ducks/auth'
import useGetSkills from 'hooks/skills/useGetSkills/useGetSkills'
import { BETESA_CATEGORY_ID } from 'constants/global.constants'
import getSkillsByFilters from 'services/common/skills/getByFilters'
import { ModelsProps, Skill } from 'types/common'
import { HEADERS, CompetencesIdealProfile } from './constants'
import { Pagination, DEFAULT_LIMIT } from 'constants/global.constants'
import _ from 'lodash'
import { useTranslation } from 'react-i18next'
import { getModels } from 'views/screens/super-admin/homologation-skills/services/getModels'
import { companyIdSelector } from 'ducks/user'
import boxImage from 'assets/images/box-icon.png'
import CardTypeTest from 'views/components/Cards/SelectTest'
import { getModelDetails } from 'views/screens/super-admin/homologation-skills/services/getModelDetails'
import { associateModelWithProcess } from 'views/screens/super-admin/homologation-skills/services/associateModelWithProcess'
import { getModelWithProcess } from 'views/screens/super-admin/homologation-skills/services/getModelWithProcess'
import sparkle from '../../../../../components/assets/sparkle.png'
import { selectCompanyData } from 'ducks/company'
import TooltipComponent from 'views/components/Tooltip'
import ModalAi from './modal-ai'
import { loadingMessages, useLimitedAttempts } from './utils'
import connectAgent from './services/connectAgent'
import AiSkills from './AiSkills/ai-skills'
import skillsCleanIcon from 'assets/images/skills-clean-icon.png'
import { saveCompetencesIdealProfile, skippedCompetencesIdealProfile } from './save-ideal-profile'
import { IdealProfileCompetences } from 'services/common/process/createProcess/create-process-service'

export interface Filters {
  levelId: number
  groupId?: number
  name?: string
  page: number
}

interface ThreeDSkillsProps {
  id: number
  name: string
}

export interface ModelSkillsProps {
  id: number
  name: string
  skills3d: ThreeDSkillsProps[]
}

export interface AiSkillsProps {
  skill_id: string
  skill: string
  ideal_profile: number
  skill_group: string
  description: string
}

const MIN_WEIGHT = 0
const MIN_SKILLS = 3
const MAX_SKILLS = 10

function ProcessSkills() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()
  const { getSkills } = useGetSkills()
  const { getWarning, getError, getSuccess } = useNotification()
  const dataStepFour = useSelector(stepFourSelector)
  const companyId = useSelector(companyIdSelector)
  const companyInfo = useSelector(selectCompanyData)
  const storagedModelSkills = JSON.parse(localStorage.getItem('modelSkills') || '[]')
  const storagedAiSkills = JSON.parse(localStorage.getItem('aiSkills') || '[]')
  const origin = localStorage.getItem('origin')
  const { process } = useSelector(rootProcessSelector)
  const stepTwoData = useSelector(rootProcessSelector).process.stepTwo
  const stepThreeData = useSelector(stepThreeSelector)
  const { data: generalData } = useSelector(generalDataSelector)
  const groupOptions = useMemo(
    () =>
      generalData?.group
        ?.filter((group: any) => group.id !== BETESA_CATEGORY_ID)
        .map((group: any) => ({ label: group.name, value: group.id })) || [],
    [generalData]
  )
  const level: number = process.stepOne.level

  const [isSavingProfile, setIsSavingProfile] = useState<boolean>(false)
  const savingProfileRef = useRef<boolean>(false)
  const [pagination, setPagination] = useState<Pagination>({ totalPages: 1, totalResults: 0 })
  const [loading, setLoading] = useState<boolean>(false)
  const [skills, setSkills] = useState<Skill[]>([])
  const [skillsSelected, setSkillsSelected] = useState<any>([])
  const [currentSkill, setCurrentSkill] = useState<any>(null)
  const [idSkillSelected, setIdSkillSelected] = useState<number[]>([])

  const [searchFilters, setSearchFilters] = useState<Filters>({ levelId: level, page: 1 })
  const [showModal, setShowModal] = useState(false)
  const [isEditedMinimumRecord, setIsEditingMinimumRecord] = useState<boolean>(false)
  const [loadingModels, setLoadingModels] = useState<boolean>(false)
  const [models, setModels] = useState<ModelsProps[]>([])
  const [showModelsSelector, setShowModelsSelector] = useState<boolean>(false)
  const [selectedModel, setSelectedModel] = useState<string>('')
  const [selected3DSkills, setSelected3DSkills] = useState<boolean>(false)
  const [modelSkills, setModelSkills] = useState<ModelSkillsProps[]>(storagedModelSkills || [])
  const [showModalAi, setShowModalAi] = useState<boolean>(false)
  const [loadingAi, setLoadingAi] = useState<boolean>(false)
  const [loadingMessage, setLoadingMessage] = useState('')
  const [aiSkills, setAiSkills] = useState<any[]>([])
  const [aiSkillsToChangeScore, setAiSkillsToChangeScore] = useState<any[]>([])
  const [showAiSkillsPage, setShowAiSkillsPage] = useState<boolean>(false)

  const { attempts, registerAttempt } = useLimitedAttempts(stepThreeData.processId)

  const messageIntervalRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    if (storagedAiSkills.length > 0) {
      if (origin === 'only_ai_skills') {
        setIsEditingMinimumRecord(false)
        setAiSkills(storagedAiSkills)
        setShowAiSkillsPage(true)
        setTimeout(() => {
          setSkillsSelected([])
        }, 3000)
      } else if (origin === 'edit_ideal_profile') {
        setAiSkillsToChangeScore(storagedAiSkills)
        setAiSkills(storagedAiSkills)
        setShowAiSkillsPage(false)
        setIsEditingMinimumRecord(true)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleCloseModalAi = () => {
    setShowModalAi(false)
  }

  const tooltipText =
    'La generación de las pruebas con IA , te sugiere competencias y puntajes de acuerdo a las caracterísiticas organizacionales y al rol; tienes dos intentos para generarlo.'

  useEffect(() => {
    if (location.state?.back) {
      setIsEditingMinimumRecord(true)
    }
  }, [location.state?.back])

  useEffect(() => {
    if (level) {
      setLoadingModels(true)
      getModels(companyId, level)
        .then((response) => {
          if (response.status === 'success') {
            setModels(response.data)
            if (!location.state?.back) {
              setShowModelsSelector(true)
            }
          }
        })
        .catch(() => {
          getError('Error al obtener los modelos')
        })
        .finally(() => {
          setLoadingModels(false)
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId, level])

  useEffect(() => {
    const competencesIdealProfile: CompetencesIdealProfile[] = dataStepFour?.competencesIdealProfile || []
    if (competencesIdealProfile.length > 0) {
      setLoading(true)
      const skillsWithWeight = competencesIdealProfile.map(async (item) => {
        try {
          const skillItem: any = await getSkills({ id: item.skill_id })
          return {
            id: item.skill_id,
            skill_id: item.skill_id,
            skill: skillItem[0].skill,
            skill_name: skillItem[0].skill,
            weight: item.weight,
          }
        } catch (error) {
          return error
        }
      })

      Promise.all(skillsWithWeight).then((resolvedSkills) => {
        const skillsWithBold = resolvedSkills.map((skill: any) => ({
          ...skill,
          isBold: skill.skill && skill.skill.includes('(Beta)')
        }))
        setSkillsSelected(skillsWithBold)
        setLoading(false)
      })
    }
  }, [dataStepFour, getSkills])

  useEffect(() => {
    if (!loading) {
      setLoading(true)
      const question = true
      getSkillsByFilters(searchFilters, searchFilters.page, DEFAULT_LIMIT, searchFilters.name, question)
        .then((response) => {
          const skillsWithBold = response.skills.map((skill: any) => ({
            ...skill,
            isBold: skill.skill && skill.skill.includes('(Beta)')
          }))
          setSkills(skillsWithBold)
          setPagination({
            totalPages: response.total_pages,
            totalResults: response?.total_results || 0,
          })
        })
        .catch(() => {
          getError('Error al obtener las competencias')
        })
        .finally(() => {
          setLoading(false)
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchFilters, searchFilters.name, searchFilters.groupId, getError, searchFilters.page])

  const stopLoadingMessages = () => {
    if (messageIntervalRef.current) {
      clearInterval(messageIntervalRef.current)
      messageIntervalRef.current = null
    }
  }

  useEffect(() => {
    return () => {
      stopLoadingMessages()
    }
  }, [])

  // MARK: HANDLERS
  const handleAddSkill = useCallback(
    (skill: Skill) => {
      if (skillsSelected.length >= MAX_SKILLS) {
        getWarning(`No puedes agregar más de ${MAX_SKILLS} competencias`)
        return {}
      }
      const skillWithBold = {
        ...skill,
        isBold: skill.skill && skill.skill.includes('(Beta)')
      }
      setSkillsSelected([skillWithBold, ...skillsSelected])
      setIdSkillSelected([skill.id, ...idSkillSelected])
      getSuccess('Competencia agregada correctamente')
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [skillsSelected, idSkillSelected]
  )

  const onDeleteSkill = useCallback(
    (skill: { id: number | string }) => {
      if (skillsSelected.length < 1) {
        getWarning('No hay competencias seleccionadas, debes volver a seleccionarlos')
      }
      const newSkillsSelected = skillsSelected.filter((item: any) => item?.id !== skill.id)
      setSkillsSelected(newSkillsSelected)
    },
    [skillsSelected, getWarning]
  )

  const handleViewNextSkill = useCallback(() => {
    const index = skills.findIndex((item) => item.id === currentSkill.id)
    if (index === skills.length - 1) {
      setCurrentSkill(skills[0])
    } else {
      setCurrentSkill(skills[index + 1])
    }
  }, [skills, currentSkill])

  const handleViewPreviousSkill = useCallback(() => {
    const index = skills.findIndex((item) => item.id === currentSkill.id)
    if (index === 0) {
      setCurrentSkill(skills[skills.length - 1])
    } else {
      setCurrentSkill(skills[index - 1])
    }
  }, [skills, currentSkill])

  const handleSearch = useCallback(
    (key: string, value: any) => {
      setSearchFilters({ ...searchFilters, [key]: value })
    },
    [searchFilters]
  )

  const handlePagination = useCallback(
    (page: number) => {
      setPagination({ ...pagination })
      setSearchFilters({ ...searchFilters, page })
    },
    [pagination, searchFilters]
  )

  const handleDefineMinimumRecord = useCallback(
    (skillsToProcess: any[]) => {
      if (skillsToProcess.length < 1) {
        getWarning('No hay competencias seleccionadas, debes volver a seleccionarlos')
        return
      }
      setIsEditingMinimumRecord(true)
    },
    [getWarning]
  )

  const hasInvalidSkills = () => {
    return skillsSelected.some((skill: any) => skill.weight <= MIN_WEIGHT || skill.weight === undefined)
  }

  const saveAndContinue = useCallback(
    async (competences: IdealProfileCompetences[], aiSkillsToStore?: any[]) => {
      if (savingProfileRef.current) return
      if (!stepThreeData?.processId || !competences.length) return

      savingProfileRef.current = true
      setIsSavingProfile(true)
      try {
        await saveCompetencesIdealProfile(stepThreeData.processId, competences)
        dispatch(setStepFour({ ...dataStepFour, processId: stepThreeData.processId, competencesIdealProfile: competences }))
        if ((aiSkillsToStore ?? []).length > 0) {
          localStorage.setItem('aiSkills', JSON.stringify(aiSkillsToStore))
        }
        navigate(stepThreeData.use360Test ? platformAdminRoutes.Process360 : platformAdminRoutes.CreateUsers)
      } catch (error) {
        getError(error instanceof Error ? error.message : 'No se pudo guardar el perfil ideal. Inténtalo de nuevo.')
      } finally {
        savingProfileRef.current = false
        setIsSavingProfile(false)
      }
    },
    [stepThreeData, dispatch, navigate, dataStepFour, getError]
  )

  const handleNextStepWithMinimumRecord = useCallback(
    async (skillsToSend: any[], aiSkillsToStore?: any[]) => {
      if (hasInvalidSkills()) {
        getWarning(`Debes asignar un puntaje mínimo de ${MIN_WEIGHT + 1} a cada competencia`)
        return
      }
      const competences: IdealProfileCompetences[] = skillsToSend.map((skill: any) => ({
        skill_id: Number(skill.id),
        weight: Number(skill.weight),
      }))
      await saveAndContinue(competences, aiSkillsToStore)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [skillsSelected, getWarning, saveAndContinue]
  )

  const handleSkipMinimumRecord = useCallback(() => {
    if (!skillsSelected.length) {
      getWarning('Debes seleccionar al menos una competencia')
      return
    }
    const competences: IdealProfileCompetences[] = skippedCompetencesIdealProfile(skillsSelected)
    void saveAndContinue(competences)
  }, [skillsSelected, getWarning, saveAndContinue])

  if (loadingModels) return <ModalLoader isLoading={loadingModels} />

  const modelOptions = models.map((model) => {
    return {
      value: model.id,
      label: model.name,
    }
  })

  const handleModelSelected = (modelId: string) => {
    setSelectedModel(modelId)
    setSelected3DSkills(false)
  }

  const handleSelect3DSkills = () => {
    setSelected3DSkills(!selected3DSkills)
    setSelectedModel('')
  }

  const handleNextWith3DSkills = () => {
    setShowModelsSelector(false)
    setModelSkills([])
  }

  const handleNextWithModel = async () => {
    if (selectedModel) {
      setLoading(true)
      try {
        const modelDetails = await getModelDetails(Number(selectedModel))
        if (modelDetails) {
          const skills3dIds = modelDetails.data.skills.flatMap((skill: ModelSkillsProps) =>
            skill.skills3d.map((s3d) => s3d.id)
          )

          const associate = await associateModelWithProcess(modelDetails.data.id, stepThreeData.processId)
          if (!associate) {
            getError('Error al asociar el modelo con el proceso')
          }

          const allSkills = await getSkillsByFilters({ levelId: level }, 1, 1000)

          const findSkills = new Set(allSkills.skills.filter((skill) => skills3dIds.includes(skill.id)))

          setSkillsSelected(Array.from(findSkills))
          setModelSkills(modelDetails.data.skills)
          localStorage.setItem('modelSkills', JSON.stringify(modelDetails.data.skills))

          handleDefineMinimumRecord(Array.from(findSkills))
          setShowModelsSelector(false)
          setLoading(false)
        } else {
          getError('Error al obtener los detalles del modelo')
          setLoading(false)
        }
      } catch (error) {
        getError('Error al obtener los detalles del modelo')
        setLoading(false)
      }
    }
  }

  const handleBackButton = async () => {
    if (stepTwoData?.configurationMode === 'ai_ideal_profile') {
      navigate(platformAdminRoutes.IdealProfileGeneratorAi)
      return
    }

    if (isEditedMinimumRecord && storagedAiSkills.length > 0) {
      setAiSkills(storagedAiSkills)
      setShowAiSkillsPage(true)
      setSkillsSelected([])
      setIsEditingMinimumRecord(false)
      return
    }
    if (isEditedMinimumRecord && !models.length) {
      setIsEditingMinimumRecord(false)
      return
    }

    if (isEditedMinimumRecord && models.length) {
      setLoading(true)
      const modelWithProcess = await getModelWithProcess(stepThreeData.processId)
      if (modelWithProcess.status === 'success') {
        if (modelSkills.length) {
          setShowModelsSelector(true)
          setSkillsSelected([])
          localStorage.removeItem('modelSkills')
        }
        setIsEditingMinimumRecord(false)
        setModelSkills([])
      } else {
        setIsEditingMinimumRecord(false)
      }
      setLoading(false)
      return
    }

    const nextRoute = stepThreeData.useBetesaTest
      ? platformAdminRoutes.IdealProfileBetesa
      : platformAdminRoutes.SelectTestsType

    if (showModelsSelector || !models.length) {
      navigate(nextRoute)
    } else {
      setShowModelsSelector(true)
    }
  }

  const handleOpenAi = () => {
    setShowModalAi(true)
  }

  // MARK: AI HANDLERS

  const startLoadingMessages = () => {
    setLoadingMessage(loadingMessages[0])

    let messageIndex = 1

    messageIntervalRef.current = setInterval(() => {
      setLoadingMessage(loadingMessages[messageIndex])
      messageIndex = (messageIndex + 1) % loadingMessages.length
    }, 8000)
  }

  const handleSendToAi = async (messages: any) => {
    startLoadingMessages()
    setLoadingAi(true)
    try {
      const body = {
        messages,
      }
      const response = await connectAgent(body)
      if (response.status === 'success' && !response.data.recommendations) {
        getWarning(response.data.message ?? (response.data.error || 'Ocurrió un error, por favor intenta nuevamente'))
      } else if (response.status === 'success') {
        getSuccess(
          `La prueba 3D Skills fue generada con éxito, ${
            attempts === 0
              ? 'te recordamos que solo te queda 1 intento disponible'
              : 'ya no te quedan más intentos disponibles'
          } con la IA para este proceso`
        )
        registerAttempt()
        setAiSkills(response.data.recommendations)
        setShowAiSkillsPage(true)
      } else {
        getError(
          'La inteligencia artificial no pudo procesar tu información en este momento, por favor genera de nuevo la prueba.'
        )
      }
    } catch (error) {
      getError('Error al conectar con el agente de IA')
    } finally {
      stopLoadingMessages()
      setLoadingAi(false)
    }
  }

  const handleDisabledClick = () => {
    getWarning('Ya has utilizado las dos consultas para este proceso')
  }

  // MARK: RENDER

  return (
    <MainLayout>
      {!models.length || !showModelsSelector ? (
        <Container>
          {aiSkills.length > 0 && showAiSkillsPage ? (
            <AiSkills
              aiSkills={aiSkills}
              setAiSkills={setAiSkills}
              skills={skills}
              searchFilters={searchFilters}
              setSearchFilters={setSearchFilters}
              handleSearch={handleSearch}
              groupOptions={groupOptions}
              pagination={pagination}
              handlePagination={handlePagination}
              handleAddSkill={handleAddSkill}
              skillsSelected={skillsSelected}
              setSkillsSelected={setSkillsSelected}
              handleDefineMinimumRecord={handleDefineMinimumRecord}
              setAiSkillsToChangeScore={setAiSkillsToChangeScore}
              handleNextStepWithMinimumRecord={handleNextStepWithMinimumRecord}
              setShowAiSkillsPage={setShowAiSkillsPage}
            />
          ) : !isEditedMinimumRecord ? (
            <>
              <ModalAi
                visible={showModalAi}
                onClose={handleCloseModalAi}
                handleSubmit={handleSendToAi}
                companyData={companyInfo}
                processLevel={skills[0]?.level_name}
              />
              <HeaderContainer>
                <TitleContainer>
                  <TitleIcon src={skillsCleanIcon} />
                  <H2 margin="30px 0px 24px 0px">{t('global.common.skillText')}</H2>
                </TitleContainer>
                <StepsContainer>
                  <Steps steps={STEPS_NEW_PROCESS} activeStep={3} />
                </StepsContainer>
              </HeaderContainer>
              <Row justify="space-between">
                <H4
                  style={{
                    width: '30%',
                  }}
                  margin="30px 0px 24px 0px"
                >
                  {t('global.common.skillText')}
                </H4>
                <SelectAndButtonContainer>
                  <SkillsSelectContainer>
                    <SubtitleBold style={{ margin: '0px 16px 0px 0px' }}>Grupos de 3D Skills:</SubtitleBold>
                    <Select
                      width="220px"
                      label="Grupos"
                      value={searchFilters?.groupId || ''}
                      onChange={(e) => {
                        if (e && e !== '0') {
                          handleSearch('groupId', e)
                        } else {
                          const filtersWithoutGroup = { ...searchFilters }
                          delete filtersWithoutGroup.groupId
                          setSearchFilters(filtersWithoutGroup)
                        }
                      }}
                      options={groupOptions}
                    />
                  </SkillsSelectContainer>
                  {companyInfo?.usesAi && (
                    <ButtonContainerAI>
                      <Button
                        onClick={handleOpenAi}
                        onDisabledClick={handleDisabledClick}
                        disabled={attempts >= 2}
                        style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
                      >
                        Generar prueba con IA
                        <SparkleIcon src={sparkle} />
                      </Button>
                      <TooltipComponent tooltipText={tooltipText} placement="top" iconColor="#2D749C" />
                    </ButtonContainerAI>
                  )}
                </SelectAndButtonContainer>
              </Row>
              <BluesiteTable
                data={skills}
                headers={HEADERS}
                isAlignLeft={true}
                searchBar={true}
                searchLabel="Buscar competencia:"
                onSearch={(e: any) => {
                  if (e !== '') {
                    handleSearch('name', e)
                  } else {
                    const filtersWithoutName = { ...searchFilters }
                    delete filtersWithoutName.name
                    setSearchFilters(filtersWithoutName)
                  }
                }}
                totalPages={pagination.totalPages}
                handlePagination={handlePagination}
                loading={false}
                ActionComponent={ActionAddSkillCreateProcess}
                currentPage={searchFilters.page}
                extraDataAction={{
                  handleAddSkill,
                  skillsSelected,
                  onViewSkill: (e: any) => {
                    setCurrentSkill(e)
                    setShowModal(true)
                  },
                }}
              />
              {skillsSelected.length > 0 && (
                <BluesiteTable
                  data={skillsSelected}
                  headers={HEADERS}
                  searchBar={false}
                  searchLabel="Buscar competencia:"
                  totalPages={0}
                  currentPage={1}
                  showNumbers
                  limit={DEFAULT_LIMIT}
                  loading={false}
                  ActionComponent={ActionDeleteSkillCreateProcess}
                  extraDataAction={{
                    onDeleteSkill,
                  }}
                />
              )}
            </>
          ) : !loading && skillsSelected.length ? (
            <MinimumRecord
              skillSelected={skillsSelected}
              model3dSkills={modelSkills}
              aiSkills={aiSkillsToChangeScore}
              onSkip={handleSkipMinimumRecord}
              isSavingProfile={isSavingProfile}
              onChange={(e: any) => {
                const skillsSelectedWithWeight = skillsSelected.map((skill: any) => {
                  const skillWithWeight = e.find((skillWithMinRecord: any) => skillWithMinRecord.skill_id === skill.id)
                  return {
                    ...skill,
                    weight: skillWithWeight.weight,
                  }
                })
                setSkillsSelected(skillsSelectedWithWeight)
              }}
            />
          ) : null}
          {!showAiSkillsPage && (
            <NextButtonContainer>
              <BackButton onClick={handleBackButton} />
              {skillsSelected.length > 0 && (
                <Button
                  onClick={
                    !isEditedMinimumRecord
                      ? () => handleDefineMinimumRecord(skillsSelected)
                      : () => handleNextStepWithMinimumRecord(skillsSelected)
                  }
                  onDisabledClick={() => {
                    /* eslint-disable */
                    skillsSelected.length < 3
                      ? getWarning(`Debes seleccionar al menos ${MIN_SKILLS} competencias`)
                      : skillsSelected.length > MAX_SKILLS
                      ? getWarning(`No puedes seleccionar más de ${MAX_SKILLS} competencias`)
                      : _.some(skillsSelected, (skill) => skill.weight === undefined || skill.weight <= MIN_WEIGHT)
                      ? getWarning(`Debes asignar un puntaje mínimo de ${MIN_WEIGHT + 1} a cada competencia`)
                      : null
                  }}
                  type="submit"
                  disabled={
                    isSavingProfile ||
                    (isEditedMinimumRecord
                      ? hasInvalidSkills() || skillsSelected.length < 1
                      : skillsSelected.length < MIN_SKILLS)
                  }
                >
                  {isSavingProfile
                    ? 'Guardando...'
                    : !isEditedMinimumRecord
                    ? 'Definir puntaje mínimo'
                    : stepThreeData?.use360Test
                    ? 'Continuar'
                    : 'Agregar usuarios'}
                </Button>
              )}
            </NextButtonContainer>
          )}
          {currentSkill && showModal && (
            <ModalSkills
              data={currentSkill}
              onClose={() => setShowModal(false)}
              visible={showModal}
              onViewNextSkill={handleViewNextSkill}
              onViewPreviousSkill={handleViewPreviousSkill}
              handleAddSkill={handleAddSkill}
              skillsSelected={skillsSelected}
            />
          )}
        </Container>
      ) : (
        <Container>
          <HeaderContainer>
            <TitleContainer>
              <TitleIcon src={skillsCleanIcon} />
              <H2 margin="30px 0px 24px 0px">¿Cómo deseas agregar las competencias de este proceso?</H2>
            </TitleContainer>
            <StepsContainer>
              <Steps steps={STEPS_NEW_PROCESS} activeStep={3} />
            </StepsContainer>
          </HeaderContainer>
          <H4
            style={{
              width: '100%',
              color: '#7E838A',
            }}
            margin="30px 0px 24px 0px"
          >
            Proceso por modelo de competencias propio
          </H4>
          <SelectContainer style={{ width: '440px' }}>
            <Select
              options={modelOptions}
              value={selectedModel}
              onChange={handleModelSelected}
              label="Selecciona el modelo de competencias"
              hideNeverChoice={true}
            />
          </SelectContainer>
          <ButtonContainer>
            <Button onClick={handleNextWithModel} disabled={!selectedModel} style={{ width: '250px' }} type="button">
              Siguiente
            </Button>
          </ButtonContainer>
          <LineContainer>
            <Line />
            <H5 color="#cbcaca" style={{ margin: '0 20px' }}>
              ó
            </H5>
            <Line />
          </LineContainer>
          <H4
            style={{
              width: '100%',
              color: '#7E838A',
              margin: '0px 0px 24px 0px',
            }}
          >
            Agregar competencias 3D Skills
          </H4>
          <CardWithBadgeContainer>
            <CardTypeTest
              title={t('global.common.skillText')}
              subtitle="Competencias del carácter"
              image={boxImage}
              onClick={handleSelect3DSkills}
              checked={selected3DSkills}
            />
            {companyInfo?.usesAi && (
              <Badge>
                Generación con IA <SparkleIcon src={sparkle} />
              </Badge>
            )}
          </CardWithBadgeContainer>
          <ButtonContainer>
            <Button
              onClick={handleNextWith3DSkills}
              disabled={!selected3DSkills}
              style={{ width: '250px' }}
              type="button"
            >
              Siguiente
            </Button>
          </ButtonContainer>
          <NextButtonContainer>
            <BackButton
              onClick={() => {
                if (stepTwoData?.configurationMode === 'ai_ideal_profile') {
                  navigate(platformAdminRoutes.IdealProfileGeneratorAi)
                } else if (stepThreeData.useBetesaTest) {
                  navigate(platformAdminRoutes.IdealProfileBetesa)
                } else {
                  navigate(platformAdminRoutes.SelectTestsType)
                }
              }}
            />
          </NextButtonContainer>
        </Container>
      )}
      <ModalLoader isLoading={loading} />
      <ModalLoader
        isLoading={loadingAi}
        text={loadingMessage}
        fontWeight={700}
        margin="30px 10px"
        fontSize="18px"
        modalStyle={{ backgroundColor: 'rgba(230, 171, 203, 0.5)' }}
      />
    </MainLayout>
  )
}

export default ProcessSkills
